// business.reducer.ts
import { createFeature, createReducer, on } from '@ngrx/store'
import {
  loadBusinessOwnersSuccess,
  loadBusinessOwnersFailure,
  loadBusinessOwners
} from './business-owner.actions'
import { BusinessOwnerState } from './business-owner.state'

export const initialState: BusinessOwnerState = {
  totalCount: 0,
  businessOwners: [],
  loading: false,
  error: null
  //   activeCount: 0,
  //   inactiveCount: 0
}

// Create the business reducer
export const businessOwnerReducer = createReducer(
  initialState,
  on(loadBusinessOwners, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadBusinessOwnersSuccess, (state, { totalCount, businessOwners }) => ({
    ...state,
    totalCount,
    businessOwners,
    loading: false,
    error: null
  })),
  on(loadBusinessOwnersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)

// Create the feature for the business state
export const businessOwnerFeature = createFeature({
  name: 'businessOwner', // Feature name
  reducer: businessOwnerReducer
})
export type { BusinessOwnerState }
// Export the feature's selectors
export const { name, reducer, selectBusinessOwners, selectLoading, selectError } =
  businessOwnerFeature
